import { AppleWallet } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconAppleWallet12Line = createIcon(AppleWallet, 12, "Line");
export const IconAppleWallet16Line = createIcon(AppleWallet, 16, "Line");
export const IconAppleWallet20Line = createIcon(AppleWallet, 20, "Line");
export const IconAppleWallet24Line = createIcon(AppleWallet, 24, "Line");
export const IconAppleWallet32Line = createIcon(AppleWallet, 32, "Line");
export const IconAppleWallet48Line = createIcon(AppleWallet, 48, "Line");
export const IconAppleWallet64Line = createIcon(AppleWallet, 64, "Line");
